/**
 * The rotation to give a vehicle icon so that its arrow points where the vehicle is going.
 *
 * Two conventions meet here and they run in opposite directions. A Geotab bearing counts degrees
 * clockwise from north. deck.gl's `IconLayer` turns an icon counter-clockwise for a positive
 * `getAngle` — its shader rotates the quad and then flips the y axis into clip space. So the sign
 * has to be turned around, and getting that wrong mirrors every arrow: a vehicle driving east
 * points west, while north and south look perfectly right.
 *
 * The map's own rotation comes off as well, so the arrow keeps pointing at the real-world heading
 * rather than at a fixed spot on the screen.
 *
 * @param deviceBearing - Where the vehicle is heading, degrees clockwise from north.
 * @param mapBearing - Which direction the map has at the top, degrees clockwise from north.
 * @returns The angle for `getAngle`, in degrees.
 */
export function vehicleIconAngle(deviceBearing: number, mapBearing: number): number {
  return mapBearing - deviceBearing;
}
